import { Logo } from '@platform/ui';
import type { ReactNode } from 'react';

import { LanguageToggle } from './LanguageToggle';

/** Centred layout shared by sign-in, sign-up and company selection. */
export function AuthLayout({ children }: { children: ReactNode }) {
    return (
        <main className="grid min-h-dvh place-items-center bg-background p-6">
            <div className="w-full max-w-104">
                <div className="mb-6 flex items-center justify-center">
                    <Logo />
                </div>
                {children}
                <div className="mt-4 flex justify-center">
                    <LanguageToggle />
                </div>
            </div>
        </main>
    );
}
